import Form from 'antd/lib/form'

import { useSignUp } from 'hooks'
import TextInput from 'components/CustomFormItem'

import {
  StyledSignUpContainer,
  StyledLeftContainer,
  StyledRightContainer,
  StyledBackground,
  StyledLogo,
  StyledDesc,
  StyledContainerPosition,
  StyledDescContainer,
  StyledBreakLine,
  StyledSignUpButton,
  StyledFormContainer,
  StyledRegisterMsg,
  StyledMinMsg,
  StyledLinksContainer,
  StyledCreateAccount,
  StyledLink,
  StyledFormsWrapper,
  StyledMainFieldsWrapper,
  StyledIressFieldsWrapper,
  // Mobile specific components
  StyledMobileFormContainer,
  StyledMobileRegisterMsg,
  StyledMobileMinMsg,
  StyledMobileFormsWrapper,
  StyledMobileMainFieldsWrapper,
  StyledMobileIressFieldsWrapper,
  StyledMobileSignUpButton,
  StyledMobileLinksContainer,
  StyledMobileSwitchLabel,
} from './SignUp.styles'

import { LoginPageImg, LogoLight } from 'assets/images'
import { Switch } from '@mui/material'
import useViewportWidth from 'hooks/useViewportWidth'

const SignUp = () => {
  const url = window.location.href
  const { width } = useViewportWidth()
  const showMobileView = width < 900 && url.includes('signup')

  const { handleSubmit, loading, hasIressDetails, handleSwitchChange, isDirectlyAuthorised, handleDirectlyAuthorisedChange } = useSignUp()

  const landingUrl = process.env.REACT_APP_STAGE === 'production' ? 'https://premiererc.co.uk/contact/' : 'https://dev.premiererc.co.uk/contact/'

  const accountTypeOptions = [
    { label: 'Adviser', value: 'adviser' },
    { label: 'Lender', value: 'lender' },
    { label: 'Administrator', value: 'administrator' },
    { label: 'Solicitor', value: 'solicitor' },
    { label: 'Professional third party', value: 'professional_third_party' },
    { label: 'Later life lending customer', value: 'later_life_lending_customer' },
  ]

  if (showMobileView) {
    return (
      <StyledMobileFormContainer>
        <StyledMobileRegisterMsg>Register now</StyledMobileRegisterMsg>
        <StyledMobileMinMsg>
          And share the right way to do equity release. Please complete one per each advisor that wishes to be registered.
        </StyledMobileMinMsg>
        <StyledMobileMinMsg
          style={{
            color: 'red',
          }}
        >
          If you don't have IRESS details please visit
          <a href={landingUrl} target="_blank" rel="noreferrer" style={{ padding: '0 5px' }}>
            PERC contact page
          </a>
          for more information.
        </StyledMobileMinMsg>
        <Form
          layout="vertical"
          size="large"
          name="basic"
          onFinish={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '10px',
          }}
        >
          <StyledMobileFormsWrapper>
            <StyledMobileMainFieldsWrapper>
              <TextInput label="First Name *" name="firstName" placeholder="Enter Your First Name" rules={['isRequired']} />
              <TextInput label="Last Name *" name="lastName" placeholder="Enter Your Last Name" rules={['isRequired']} />
              <TextInput label="Email *" name="email" placeholder="Enter Your Email" rules={['isRequired', 'validateEmail']} />
              <TextInput label="Phone Number *" name="phoneNumber" placeholder="Enter Your Phone Number" rules={['isRequired']} />
              <TextInput label="Mobile Number" name="mobileNumber" placeholder="Enter Your Mobile Number" />
              <TextInput label="Password *" name="password" type="password" placeholder="Enter a password" rules={['isRequired']} />
              <TextInput
                label="Account Type *"
                name="accountType"
                type="select"
                placeholder="Select Account Type"
                options={accountTypeOptions}
                rules={['isRequired']}
              />
              <TextInput label="FCA Number" name="fcaNumber" placeholder="Enter Your FCA Number" type="number" />

              <StyledMobileSwitchLabel htmlFor="isDirectlyAuthorised">
                <Switch
                  onChange={handleDirectlyAuthorisedChange}
                  checked={isDirectlyAuthorised}
                  name="isDirectlyAuthorised"
                  id="isDirectlyAuthorised"
                  size="small"
                />
                Are you directly authorised?
              </StyledMobileSwitchLabel>

              {!isDirectlyAuthorised && <TextInput label="Network Details" name="networkDetails" placeholder="Enter Network Details" />}

              <StyledMobileSwitchLabel htmlFor="hasIressDetails">
                <Switch onChange={handleSwitchChange} checked={hasIressDetails} name="hasIressDetails" id="hasIressDetails" size="small" />I have IRESS Details
              </StyledMobileSwitchLabel>
            </StyledMobileMainFieldsWrapper>
            {hasIressDetails && (
              <StyledMobileIressFieldsWrapper>
                <TextInput label="Iress Login ID *" name="iressLoginId" placeholder="Enter Your Iress Login ID" rules={['isRequired']} />
                <TextInput label="Iress Password *" name="iressPassword" placeholder="Enter Your Iress Password" rules={['isRequired']} />
                <TextInput label="Iress User ID *" name="iressUserId" placeholder="Enter Your Iress User ID" type="number" rules={['isRequired']} />
                <StyledMobileMinMsg
                  style={{
                    color: 'red',
                  }}
                >
                  Please double check IRESS details for accuracy!
                </StyledMobileMinMsg>
              </StyledMobileIressFieldsWrapper>
            )}
          </StyledMobileFormsWrapper>
          <StyledMobileSignUpButton loading={loading} type="primary" htmlType="submit">
            REGISTER
          </StyledMobileSignUpButton>
          <StyledMobileLinksContainer>
            <StyledCreateAccount>Already have an account?</StyledCreateAccount>
            <StyledLink to="/">Log In</StyledLink>
          </StyledMobileLinksContainer>
        </Form>
      </StyledMobileFormContainer>
    )
  }

  return (
    <StyledSignUpContainer>
      <StyledLeftContainer>
        <StyledBackground img={LoginPageImg}>
          <StyledLogo src={LogoLight} />
          <StyledContainerPosition>
            <StyledDescContainer>
              <StyledBreakLine />
              <StyledDesc>The platform for later life lending professionals</StyledDesc>
            </StyledDescContainer>
          </StyledContainerPosition>
        </StyledBackground>
      </StyledLeftContainer>
      <StyledRightContainer>
        <StyledFormContainer>
          <StyledRegisterMsg>Register now</StyledRegisterMsg>
          <StyledMinMsg>And share the right way to do equity release. Please complete one per each advisor that wishes to be registered.</StyledMinMsg>
          <StyledMinMsg
            style={{
              color: 'red',
            }}
          >
            If you don't have IRESS details please visit
            <a href={landingUrl} target="_blank" rel="noreferrer" style={{ padding: '0 10px' }}>
              PERC contact page
            </a>
            for more information.
          </StyledMinMsg>
          <Form
            layout="vertical"
            size="large"
            name="basic"
            onFinish={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '12px',
            }}
          >
            <StyledFormsWrapper>
              <StyledMainFieldsWrapper
                style={{
                  width: hasIressDetails ? '100%' : '50%',
                }}
              >
                <TextInput label="First Name *" name="firstName" placeholder="Enter Your First Name" rules={['isRequired']} />
                <TextInput label="Last Name *" name="lastName" placeholder="Enter Your Last Name" rules={['isRequired']} />
                <TextInput label="Email *" name="email" placeholder="Enter Your Email" rules={['isRequired', 'validateEmail']} />
                <TextInput label="Phone Number *" name="phoneNumber" placeholder="Enter Your Phone Number" rules={['isRequired']} />
                <TextInput label="Mobile Number" name="mobileNumber" placeholder="Enter Your Mobile Number" />
                <TextInput label="Password *" name="password" type="password" placeholder="Enter a password" rules={['isRequired']} />
                <TextInput
                  label="Account Type *"
                  name="accountType"
                  type="select"
                  placeholder="Select Account Type"
                  options={accountTypeOptions}
                  rules={['isRequired']}
                />
                <TextInput label="FCA Number" name="fcaNumber" placeholder="Enter Your FCA Number" type="number" />

                <label htmlFor="isDirectlyAuthorised">
                  <Switch onChange={handleDirectlyAuthorisedChange} checked={isDirectlyAuthorised} name="isDirectlyAuthorised" id="isDirectlyAuthorised" />
                  Are you directly authorised?
                </label>

                {!isDirectlyAuthorised && <TextInput label="Network Details" name="networkDetails" placeholder="Enter Network Details" />}

                <label htmlFor="hasIressDetails">
                  <Switch onChange={handleSwitchChange} checked={hasIressDetails} name="hasIressDetails" id="hasIressDetails" />I have IRESS Details
                </label>
              </StyledMainFieldsWrapper>
              {hasIressDetails && (
                <StyledIressFieldsWrapper>
                  <TextInput label="Iress Login ID *" name="iressLoginId" placeholder="Enter Your Iress Login ID" rules={['isRequired']} />
                  <TextInput label="Iress Password *" name="iressPassword" placeholder="Enter Your Iress Password" rules={['isRequired']} />
                  <TextInput label="Iress User ID *" name="iressUserId" placeholder="Enter Your Iress User ID" type="number" rules={['isRequired']} />
                  <StyledMinMsg
                    style={{
                      color: 'red',
                    }}
                  >
                    Please double check IRESS details for accuracy!
                  </StyledMinMsg>
                </StyledIressFieldsWrapper>
              )}
            </StyledFormsWrapper>
            <StyledSignUpButton loading={loading} type="primary" htmlType="submit">
              REGISTER
            </StyledSignUpButton>
            <StyledLinksContainer>
              <StyledCreateAccount>Already have an account?</StyledCreateAccount>
              <StyledLink to="/">Log In</StyledLink>
            </StyledLinksContainer>
          </Form>
        </StyledFormContainer>
      </StyledRightContainer>
    </StyledSignUpContainer>
  )
}

export default SignUp
